import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/articles";
import type { Article } from "@/mocks/articles";

export default function ArticleAside({ article }: { article: Article }) {
  const board = [...hotArticles].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <aside className="flex flex-col gap-5">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <span className="flex h-5 w-5 items-center justify-center text-primary-500">
            <i className="ri-fire-fill"></i>
          </span>
          爆料热榜
        </h3>
        <ol className="mt-4 space-y-1">
          {board.map((item, index) => (
            <li key={item.id} className="flex items-start gap-3 border-b border-background-200 py-3 last:border-0">
              <span
                className={`flex h-5 w-5 flex-none items-center justify-center rounded-md font-heading text-[11px] font-bold ${
                  index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              <Link
                to={`/article/${item.id}`}
                className="cursor-pointer font-heading text-sm leading-snug text-foreground-800 transition-colors hover:text-primary-600"
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950">本文标签</h3>
        <div className="mt-4 flex flex-wrap gap-2">
          {article.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-background-100 px-2.5 py-1 text-xs text-foreground-600"
            >
              {tag}
            </span>
          ))}
          <Link
            to={`/?cat=${article.categorySlug}#latest`}
            className="cursor-pointer rounded-md bg-primary-50 px-2.5 py-1 text-xs text-primary-700 transition-colors hover:bg-primary-100"
          >
            #{article.category}
          </Link>
        </div>
      </div>

      <div className="rounded-lg bg-primary-950 p-5">
        <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-accent-400">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-mail-send-line"></i>
          </span>
          每周深扒
        </p>
        <p className="mt-3 text-sm leading-relaxed text-background-200">
          订阅后每周收到三篇精选深扒和一条独家线索进展，不发广告。
        </p>
        <Link
          to="/#subscribe"
          className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
        >
          免费订阅
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </aside>
  );
}